import React, { Component } from "react";
import SeniorenplatformFilter from '../SeniorenplatformFilter/SeniorenplatformFilter';

export default class SeniorenplatformFilterList extends Component {
    constructor(props) {
        super();
        this.filter = {
            favourites: [
                "Alle favorieten"
            ]
        };
    }

    render() {
        return (
            <div className={`c-senioren__filters${this.props.filterMobileValue === true ? "--mobile" : ""}`}> {/*dynamisch maken */}
                <div className="c-senioren__filters--header">
                    {this.props.filterMobileValue === true &&
                        <button className="c-senioren__button c-senioren__button--close" onClick={() => this.props.filterMobile()}><i className="fa fa-close"></i></button>
                    }
                    <h3>{this.props.dictionary.filteren}</h3>
                </div>
                {
                    this.props.isLoggedin && <SeniorenplatformFilter
                        label="Mijn favorieten"
                        filter={this.filter.favourites}
                        handleCheckbox={this.props.handleFavouritesCheckbox}
                    />
                }
                <SeniorenplatformFilter
                    label={this.props.dictionary.categorieen}
                    filter={this.props.filters.categories}
                    activeFilters={this.props.activeFilters?.selectedCategories}
                    handleCheckbox={this.props.handleCategoriesCheckbox}
                />
                <SeniorenplatformFilter
                    label={this.props.dictionary.krachtoefeningen}
                    filter={this.props.filters.musclegroups}
                    activeFilters={this.props.activeFilters?.selectedMuscleGroups}
                    handleCheckbox={this.props.handleMuscleGroupsCheckbox}
                />
                <SeniorenplatformFilter
                    label={this.props.dictionary.typeOefening}
                    filter={this.props.filters.types}
                    activeFilters={this.props.activeFilters?.selectedTypes}
                    handleCheckbox={this.props.handleTypesCheckbox}
                />
                <SeniorenplatformFilter
                    label={this.props.dictionary.deelnemers}
                    filter={this.props.filters.participants}
                    activeFilters={this.props.activeFilters?.selectedParticipants}
                    handleCheckbox={this.props.handleParticipantsCheckbox}
                />
                <SeniorenplatformFilter
                    label={this.props.dictionary.benodigdheden}
                    filter={this.props.filters.equipments.map(e => e.display)}
                    activeFilters={this.props.activeFilters?.selectedEquipments}
                    handleCheckbox={this.props.handleEquipmentsCheckbox}
                />
                {this.props.filterMobileValue === true &&
                    <button className="c-senioren__button c-senioren__button--secondary c-senioren__button--results" onClick={() => this.props.filterMobile()}>{this.props.dictionary.toonResultaten} ({this.props.totalItems})</button>
                }
            </div>
        );
    }
}